export default "__VITE_ASSET__BUNtb2MI__"